import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

const ProtectedRoute = ({ children, adminOnly = false, contributorOnly = false }) => {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) {
    // Rediriger vers la bonne page de connexion selon le type de route
    if (contributorOnly) {
      return <Navigate to="/contributor/login" replace />;
    }
    return <Navigate to="/admin/login" replace />;
  }

  // Si route réservée aux admins
  if (adminOnly && user?.role !== 'admin') {
    return <Navigate to="/admin" replace />;
  }

  // Si route réservée aux contributeurs
  if (contributorOnly && user?.role !== 'contributor') {
    // Si admin/rédacteur essaie d'accéder, rediriger vers admin
    if (user?.role === 'admin' || user?.role === 'redacteur') {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to="/contributor/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

